/**
 * This is a local restriction adapter that resolves true or false
 * depending on the device type as specified by DeviceVariance. If
 * a DeviceVariance drops the device type into the context, we
 * can check it and resolve the restriction.
 *
 * The restriction can be defined to have a list of whitelisted
 * device values:
 *
 * device:phone,tablet
 *
 */
import dlv from 'dlv';

export const NAME = '^device:(.+)$';

// The default value if the device is not actually defined in context.
const resultIfNoDevice = true;

export default function isAllowed(restriction, _, context = {}) {
	let match = restriction.match(NAME);
	let result = context.device || dlv(window, 'iMDS.Device', '') || resultIfNoDevice;
	if (match.length > 1) {
		result = match[1].split(',').map(key => key.trim()).some(key => key === result);
	}
	return result;
}
